// extracted by mini-css-extract-plugin
export var numberInputContainer = "_9x-0";
export var startPickingButton = "_9x-1";